import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { Card, CardContent } from '@guildeducationinc/recess';
import { MONTHLY_ACTIVITY } from '@src/graphql/queries/dashboard';
import { DataTable, useLocale } from 'pe-core-frontend';
import { useMemo } from 'react';
import styles from './DashboardMonthlyActivity.module.scss';
export const DashboardMonthlyActivity = ({ client, year }) => {
    const { t, intl, formatCurrency } = useLocale();
    const { data: monthlyActivity, loading } = useQuery(MONTHLY_ACTIVITY, {
        variables: {
            spec: {
                clientId: client.id,
                capYear: year,
            },
        },
    });
    const rows = useMemo(() => {
        if (!monthlyActivity?.monthlyActivity)
            return [];
        return monthlyActivity.monthlyActivity.map((activity) => ({
            ...activity,
            id: activity.month,
            month: intl.formatDate(activity.month, {
                year: 'numeric',
                month: 'long',
                timeZone: 'UTC', // this is okay to use UTC because report generated in UTC on the server
            }),
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [monthlyActivity]);
    return (_jsx(Card, { className: styles.dashboardMonthlyActivity, children: _jsxs(CardContent, { children: [_jsx("h3", { children: t('Monthly Activity') }), _jsx(DataTable, { disableColumnMenu: true, disableRowSelectionOnClick: true, loading: loading, rows: rows, pageSizeOptions: [], hideFooter: true, columns: [
                        {
                            field: 'month',
                            headerName: t('Month'),
                            sortable: false,
                            flex: 0.2,
                        },
                        {
                            field: 'amountApproved',
                            headerName: t('Payment Approved'),
                            sortable: false,
                            flex: 0.2,
                            headerAlign: 'right',
                            align: 'right',
                            renderCell: ({ value }) => formatCurrency(value, client.clientConfig.currency, true),
                        },
                        {
                            field: 'programCount',
                            headerName: t('Num Programs'),
                            sortable: false,
                            headerAlign: 'right',
                            align: 'right',
                            flex: 0.2,
                        },
                        {
                            field: 'paymentRequestCount',
                            headerName: t('Num Payment Requests'),
                            sortable: false,
                            headerAlign: 'right',
                            align: 'right',
                            flex: 0.2,
                        },
                        {
                            field: 'approvedCount',
                            headerName: t('Num Approved'),
                            sortable: false,
                            headerAlign: 'right',
                            align: 'right',
                            flex: 0.2,
                        },
                        {
                            field: 'rejectedCount',
                            headerName: t('Num Rejected'),
                            sortable: false,
                            headerAlign: 'right',
                            align: 'right',
                            flex: 0.2,
                        },
                    ] })] }) }));
};
